
import CustomForm from './CustomForm/CustomForm';

CustomForm.install = function (Vue) {
  Vue.component(CustomForm.name, CustomForm)
}

export default CustomForm;
